module.exports = __webpack_public_path__ + "img/x1.1c1de456.jpg";